import {
  aggregatedRideReportTypes,
  ReportType,
} from '@component/LightVersion/Reports/ride-reports/constants';

export const baseColumns = [
  {
    key: 'fullName',
    field: 'fullName',
    label: 'Member Name',
    headerName: 'Member Name',
    type: 'text',
    isFilterable: false,
    sortingField: 'fullName',
    isSortable: true,
    isChecked: false,
  },
  {
    key: 'memberIdNumber',
    field: 'memberIdNumber',
    label: 'Member ID',
    headerName: 'Member ID',
    type: 'text',
    isFilterable: false,
    sortingField: 'memberIdNumber',
    isSortable: true,
    isChecked: false,
  },
  {
    key: 'dateOfService',
    field: 'dateOfService',
    label: 'Date of Service',
    headerName: 'Date of Service',
    type: 'text',
    isFilterable: false,
    sortingField: 'dateOfService',
    isSortable: true,
    isChecked: false,
  },
  {
    key: 'confirmationCode',
    field: 'confirmationCode',
    label: 'Confirmation Code',
    headerName: 'Confirmation Code',
    type: 'text',
    isFilterable: false,
    sortingField: 'confirmationCode',
    isSortable: true,
    isChecked: false,
  },
  {
    key: 'levelOfService',
    field: 'levelOfService',
    label: 'Level of Service',
    headerName: 'Level of Service',
    type: 'text',
    isFilterable: false,
    sortingField: 'levelOfService',
    isSortable: true,
    isChecked: false,
  },
  {
    key: 'serviceType',
    field: 'serviceType',
    label: 'Rendering Service',
    headerName: 'Rendering Service',
    type: 'text',
    isFilterable: false,
    sortingField: 'serviceType',
    isSortable: true,
    isChecked: false,
  },
  {
    key: 'serviceTypeCategory',
    field: 'serviceTypeCategory',
    label: 'Rendering Service Category',
    headerName: 'Rendering Service Category',
    type: 'text',
    isFilterable: false,
    sortingField: 'serviceTypeCategory',
    isSortable: true,
    isChecked: false,
  },
  {
    key: 'averageRideCost',
    field: 'averageRideCost',
    label: 'Average Ride Cost',
    headerName: 'Average Ride Cost',
    type: 'text',
    isFilterable: false,
    sortingField: 'averageRideCost',
    isSortable: true,
    isChecked: false,
  },
  {
    key: 'totalRideCost',
    field: 'totalRideCost',
    label: 'Total Ride Cost',
    headerName: 'Total Ride Cost',
    type: 'text',
    isFilterable: false,
    sortingField: 'totalRideCost',
    isSortable: true,
    isChecked: false,
  },
  {
    key: 'pickupAddress',
    field: 'pickupAddress',
    label: 'Pickup Address',
    headerName: 'Pickup Address',
    type: 'text',
    isFilterable: false,
    sortingField: 'pickupAddress',
    isSortable: true,
    isChecked: false,
  },
  {
    key: 'pickupAddressCounty',
    field: 'pickupAddressCounty',
    label: 'Pickup Address County',
    headerName: 'Pickup Address County',
    type: 'text',
    isFilterable: false,
    sortingField: 'pickupAddressCounty',
    isSortable: true,
    isChecked: false,
  },
  {
    key: 'dropOffAddress',
    field: 'dropOffAddress',
    label: 'Drop-off Address',
    headerName: 'Drop-off Address',
    type: 'text',
    isFilterable: false,
    sortingField: 'dropOffAddress',
    isSortable: true,
    isChecked: false,
  },
  {
    key: 'dropOffAddressCounty',
    field: 'dropOffAddressCounty',
    label: 'Drop-off County',
    headerName: 'Drop-off County',
    type: 'text',
    isFilterable: false,
    sortingField: 'dropOffAddressCounty',
    isSortable: true,
    isChecked: false,
  },
  {
    key: 'rideStatus',
    field: 'rideStatus',
    label: 'Ride Status',
    headerName: 'Ride Status',
    type: 'text',
    isFilterable: false,
    sortingField: 'rideStatus',
    isSortable: true,
    isChecked: false,
  },
  {
    key: 'contractor',
    field: 'contractor',
    label: 'Contractor',
    headerName: 'Contractor',
    type: 'text',
    isFilterable: false,
    sortingField: 'contractor',
    isSortable: true,
    isChecked: false,
  },
  {
    key: 'willCallIndicator',
    field: 'willCallIndicator',
    label: 'Will Call Indicator',
    headerName: 'Will Call Indicator',
    type: 'text',
    isFilterable: false,
    sortingField: 'willCallIndicator',
    isSortable: true,
    isChecked: false,
  },
  {
    key: 'statusGroup',
    field: 'statusGroup',
    label: 'Status Group',
    headerName: 'Status Group',
    type: 'status',
    isFilterable: false,
    sortingField: 'statusGroup',
    isSortable: true,
    isChecked: false,
  },
  {
    key: 'cost',
    field: 'cost',
    label: 'Cost',
    headerName: 'Cost',
    type: 'text',
    isFilterable: false,
    sortingField: 'cost',
    isSortable: true,
    isChecked: false,
  },
  {
    key: 'estMiles',
    field: 'estMiles',
    label: 'Estimated Miles',
    headerName: 'Estimated Miles',
    type: 'text',
    isFilterable: false,
    sortingField: 'estMiles',
    isSortable: true,
    isChecked: false,
  },
  {
    key: 'actualMiles',
    field: 'actualMiles',
    label: 'Actual Miles',
    headerName: 'Actual Miles',
    type: 'text',
    isFilterable: false,
    sortingField: 'actualMiles',
    isSortable: true,
    isChecked: false,
  },
  {
    key: 'statusChangedDate',
    field: 'statusChangedDate',
    label: 'Status Changed Date',
    headerName: 'Status Changed Date',
    type: 'text',
    isFilterable: false,
    sortingField: 'statusChangedDate',
    isSortable: true,
    isChecked: false,
  },
  {
    key: 'pickupTime',
    field: 'pickupTime',
    label: 'Pickup Time',
    headerName: 'Pickup Time',
    type: 'text',
    isFilterable: false,
    sortingField: 'pickupTime',
    isSortable: true,
    isChecked: false,
  },
  {
    key: 'actualPickupTime',
    field: 'actualPickupTime',
    label: 'Actual Pickup Time',
    headerName: 'Actual Pickup Time',
    type: 'text',
    isFilterable: false,
    sortingField: 'actualPickupTime',
    isSortable: true,
    isChecked: false,
  },
  {
    key: 'onTimeStatus',
    field: 'onTimeStatus',
    label: 'On Time Status',
    headerName: 'On Time Status',
    type: 'text',
    isFilterable: false,
    sortingField: 'onTimeStatus',
    isSortable: true,
    isChecked: false,
  },
  {
    key: 'firstDateOfService',
    field: 'firstDateOfService',
    label: 'First Date of Service',
    headerName: 'First Date of Service',
    type: 'text',
    isFilterable: false,
    sortingField: 'firstDateOfService',
    isSortable: true,
    isChecked: false,
  },
  {
    key: 'lastDateOfService',
    field: 'lastDateOfService',
    label: 'Last Date of Service',
    headerName: 'Last Date of Service',
    type: 'text',
    isFilterable: false,
    sortingField: 'lastDateOfService',
    isSortable: true,
    isChecked: false,
  },
  {
    key: 'countOnTimeTrips',
    field: 'countOnTimeTrips',
    label: 'Count On Time Trips',
    headerName: 'Count On Time Trips',
    type: 'text',
    isFilterable: false,
    sortingField: 'countOnTimeTrips',
    isSortable: true,
    isChecked: false,
  },
  {
    key: 'countLateTrips',
    field: 'countLateTrips',
    label: 'Count Late Trips',
    headerName: 'Count Late Trips',
    type: 'text',
    isFilterable: false,
    sortingField: 'countLateTrips',
    isSortable: true,
    isChecked: false,
  },
  {
    key: 'percentageOnTime',
    field: 'percentageOnTime',
    label: 'Percentage On Time',
    headerName: 'Percentage On Time',
    type: 'percent',
    isFilterable: false,
    sortingField: 'percentageOnTime',
    isSortable: true,
    isChecked: false,
  },
  {
    key: 'percentageLate',
    field: 'percentageLate',
    label: 'Percentage Late',
    headerName: 'Percentage Late',
    type: 'percent',
    isFilterable: false,
    sortingField: 'percentageLate',
    isSortable: true,
    isChecked: false,
  },
  {
    key: 'countRide',
    field: 'countRide',
    label: 'Count Rides',
    headerName: 'Count Rides',
    type: 'text',
    isFilterable: false,
    sortingField: 'countRide',
    isSortable: true,
    isChecked: false,
  },
  {
    key: 'lob',
    field: 'lob',
    label: 'Line of Business',
    headerName: 'Line of Business',
    type: 'text',
    isFilterable: false,
    sortingField: 'lob',
    isSortable: true,
    isChecked: false,
  },
];

const exceptions = ['totalRideCost', 'lob'];

export const getRideReportSelectableColumns = (reportType: ReportType) => {
  if (aggregatedRideReportTypes.includes(reportType)) {
    return baseColumns;
  }

  return baseColumns.filter((column) => !exceptions.includes(column.key));
};
